<div class="partner-component">

  @for (partnerFormGroup of partnerFormGroups(); track partnerFormGroup; let index = $index) {
    <ng-container class="separator">
      <div [class.partner-card]="kybMode">
      <div class="row separator-bottom">
        <div class="col-12">
          <div class="application-subsection-title">Partner {{index + 1}}</div>
          <div class="mat-body separator-bottom">Minimum 2 partners required</div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <mat-button-toggle-group
            [hideSingleSelectionIndicator]="true"
            [hideMultipleSelectionIndicator]="true"
            [formControl]="partnerFormGroupFormControl(partnerFormGroup, 'type')">
            <mat-button-toggle value="Entity">Entity</mat-button-toggle>
            <mat-button-toggle value="Individual">Individual</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
      <!-- INDIVIDUAL -->
      @if (partnerFormGroupFormControl(partnerFormGroup, 'type').value === 'Individual' &&
        (partnerFormGroupFormControl(partnerFormGroup, 'firstName') || partnerFormGroupFormControl(partnerFormGroup, 'individual'))) {
        @if (kybMode) {
          <div>
            @if (isKybIndividualComplete(partnerFormGroup)) {
              <table class="kyb-people-table separator-bottom">
                <thead>
                  <tr>
                    <th class="col-select"></th>
                    <th class="col-name">Name</th>
                    <th class="col-role">Business Role</th>
                    <th class="col-ownership">Ownership %</th>
                    <th class="col-tick">Guarantor</th>
                    <th class="col-tick">Signer</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="col-select"><mat-checkbox [checked]="true" [disabled]="true"></mat-checkbox></td>
                    <td class="col-name">{{ kybIndividualName(partnerFormGroup) }}</td>
                    <td class="col-role">Partner</td>
                    <td class="col-ownership">-</td>
                    <td class="col-tick"><mat-checkbox [checked]="true" [disabled]="true"></mat-checkbox></td>
                    <td class="col-tick"><mat-checkbox [checked]="true" [disabled]="true"></mat-checkbox></td>
                  </tr>
                </tbody>
              </table>
            }
            <div class="row separator-bottom">
              <div class="col-12">
                <button mat-stroked-button class="mr-2" (click)="openKybIndividualDialog(partnerFormGroup)">
                  <span class="mdi mdi-pencil" matPrefix></span>
                  {{ isKybIndividualComplete(partnerFormGroup) ? 'Edit details' : 'Enter details' }}
                </button>
                @if (canRemovePartner()) {
                  <button mat-stroked-button color="warn" (click)="removePartner(partnerFormGroup)">Remove Partner</button>
                }
              </div>
            </div>
          </div>
        } @else {
        <div class="row">
          <div class="col-12">
            <individual-form
              [mark]="markObservable"
              [showAddressForm]="showAddressForm"
              [showIdentification]="showIdentification"
              [formControl]="partnerFormGroupFormControl(partnerFormGroup, 'individual')">
            </individual-form>
          </div>
        </div>
        @if (canRemovePartner()) {
          <div class="row separator-bottom">
            <div class="col-12">
              <button mat-stroked-button color="warn" (click)="removePartner(partnerFormGroup)">Remove Partner</button>
            </div>
          </div>
        }
        @if (showAssetsAndLiabilities) {
          <div>
            <personal-assets
              [mark]="markObservable"
              (events)="onPersonalAssetEvent($event, partnerFormGroup)"
            [formControl]="partnerFormGroupFormControl(partnerFormGroup, 'personalAssets')"></personal-assets>
          </div>
        }
        @if (showAssetsAndLiabilities) {
          <div>
            <personal-liabilities
              [mark]="markObservable"
              (events)="onPersonalLiabilitiesEvent($event, partnerFormGroup)"
            [formControl]="partnerFormGroupFormControl(partnerFormGroup, 'personalLiabilities')"></personal-liabilities>
          </div>
        }
        }
      }
      <!-- ENTITY -->
      @if (partnerFormGroupFormControl(partnerFormGroup, 'type').value === 'Entity' &&
        partnerFormGroupFormControl(partnerFormGroup, 'organisation')) {
        <div class="row">
          <div class="col-lg-6 col-md-12">
            <business-number-search
              [mark]="markObservable"
              [searchFn]="businessNumberSearchFn"
            [formControl]="partnerFormGroupFormControl(partnerFormGroup, 'organisation')"></business-number-search>
          </div>
          <div class="col-lg-3 col-md-12">
            <entity-type
              [readonly]="entityTypeReadonly"
              [mark]="markObservable"
              [formControl]="partnerFormGroupFormControl(partnerFormGroup, 'organisationType')">
            </entity-type>
          </div>
        </div>
        @if (canRemovePartner()) {
          <div class="row separator-bottom">
            <div class="col-12">
              <button mat-stroked-button color="warn" (click)="removePartner(partnerFormGroup)">Remove Partner</button>
            </div>
          </div>
        }
        @if (kybMode) {
          @if (!hasNestedParties(partnerFormGroup)) {
            <div class="row separator-bottom">
              <div class="col-12">
                <button mat-stroked-button (click)="toggleSigners(partnerFormGroup)">
                  <span class="mdi mdi-account-check" matPrefix></span>
                  Select signers
                </button>
              </div>
            </div>
            @if (isSignersVisible(partnerFormGroup)) {
              <div class="row separator-bottom">
                <div class="col-12">
                  @if (signerEntity(partnerFormGroup); as partnerSignerEntity) {
                    @if (partnerSignerEntity.entity.mode === 'MANUAL') {
                      <manual-kyb-people
                        [commercialEntityId]="partnerSignerEntity.entity.commercialEntityId"
                        [initialPeople]="partnerSignerEntity.entity.manualPeople"
                        [showWaitingMessage]="showManualWaitingMessage(partnerSignerEntity)"
                        (peopleChange)="manualPeopleChange.emit({commercialEntityId: partnerSignerEntity.entity.commercialEntityId, people: $event})"
                        (validChange)="manualValidityChange.emit({commercialEntityId: partnerSignerEntity.entity.commercialEntityId, valid: $event})">
                      </manual-kyb-people>
                    } @else if (partnerSignerEntity.status === 'resolved') {
                      <kyb-entity-section
                        [entity]="partnerSignerEntity.entity"
                        [entityType]="signerEntityType"
                        [forceShowPeople]="true"
                        [showHeader]="false"
                        [allowManualEntry]="allowManualEntry"
                        [guarantorLockedStakeholderIds]="guarantorLockedStakeholderIds"
                        (personRoleChange)="personRoleChange.emit($event)"
                        (personSelectedChange)="personSelectedChange.emit($event)"
                        (manualEntry)="startManualKyb(partnerSignerEntity)">
                      </kyb-entity-section>
                    } @else {
                      <!-- The run is still in flight or stalled. kyb-status owns the wait for this
                           company's own check, exactly as the company details step does for the
                           applicant: it polls until the check lands, and its Retry pulls the
                           execution from FrankieOne rather than starting a second one. -->
                      <kyb-status
                        [applicationId]="partnerSignerEntity.applicationId"
                        [commercialEntityId]="partnerSignerEntity.entity.commercialEntityId"
                        [businessName]="partnerSignerEntity.entity.entityName"
                        [pollFn]="partnerSignerEntity.pollFn"
                        [refreshFn]="partnerSignerEntity.refreshFn"
                        (manualEntry)="startManualKyb(partnerSignerEntity)"
                        (resolved)="signerResolved.emit($event)">
                      </kyb-status>
                    }
                  } @else {
                    <!-- The row's own check has been asked for but its entity is not in the read
                         model yet, so there is nothing to poll on: the panel waits in presentational
                         mode and its Retry re-reads the model, which is what makes the run visible
                         and hands the wait over to the polling panel above. -->
                    <kyb-status
                      [status]="'pending'"
                      [businessName]="signerBusinessName(partnerFormGroup)"
                      (retry)="signerRetry.emit()">
                    </kyb-status>
                  }
                </div>
              </div>
            }
          }
          @if (nestedPartyTemplate) {
            <ng-container
              *ngTemplateOutlet="nestedPartyTemplate; context: {$implicit: partnerFormGroup}">
            </ng-container>
          }
        }
      }
      </div>
    </ng-container>
  }

  <div class="row separator-bottom">
    <div class="col-12">
      @if (kybMode) {
        <button mat-stroked-button (click)="addKybIndividual()">
          <span class="mdi mdi-plus" matPrefix></span>
          Add Partner
        </button>
      } @else {
        <button mat-stroked-button (click)="addPartner()">
          <span class="mdi mdi-plus" matPrefix></span>
          Add Partner
        </button>
      }
    </div>
  </div>

  <div class="row separator-bottom error-messages">
    @for (errorKey of errorKeys(formArray); track errorKey) {
      <mat-error>
        @if (formArray.hasError(errorKey)) {
          <message-box type="danger">
            {{errorMessage(formArray, errorKey)}}
          </message-box>
        }
      </mat-error>
    }
  </div>

</div>
